module.exports = __webpack_public_path__ + "static/media/TLOS.e120a590.svg";